<template>
    <el-image
            class="brand-image"
            :src="url"
            fit="contain">
    </el-image>
</template>

<script>
  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @returns {string}
       */
      url() {
        return this.row.model.logo;
      }
    }
  }
</script>

<style scoped>
    .brand-image {
        width: 100px;
        height: 50px
    }
</style>
